import { render } from "./AddDocument.vue?vue&type=template&id=91555f64"
import script from "./AddDocument.vue?vue&type=script&lang=ts"
export * from "./AddDocument.vue?vue&type=script&lang=ts"

import "./AddDocument.vue?vue&type=style&index=0&id=91555f64&lang=css"
script.render = render

export default script